import { Container, Grid } from '@mui/material';
import './bidask.css'

import ReplayPanel from './baseNewComponent';

const BidAskComponent2 = () => {

    return (
        <div className="w-full min-h-screen bg-[#0b111a] text-white px-6 py-6">
            <div className="max-w-[1800px] mx-auto">

                {/* HEADER */}
                <div style={{display: 'none'}} className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-3 text-lg font-semibold">
                        <span>📊</span>
                        <span>BidAsk Replay</span>
                    </div>

                    <button className="px-3 py-1 text-xs bg-slate-700 hover:bg-slate-600 rounded">
                        Sync Panels
                    </button>
                </div>

                {/* TWO PANELS */}
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                    {ReplayPanel(1, undefined)}
                    {ReplayPanel(2, undefined)}
                </div>

            </div>
        </div>
    );
};

export default BidAskComponent2;
